var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebsiteSdkSmallIcon = function SvgWebsiteSdkSmallIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15528_34338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1C5.0295 1 1 5.0295 1 10C1 14.9705 5.0295 19 10 19C14.9705 19 19 14.9705 19 10C19 5.0295 14.9705 1 10 1ZM2.025 10.5H4.0165C4.0625 11.753 4.2775 12.9355 4.631 14H3.079C2.4755 12.9585 2.104 11.7705 2.025 10.5V10.5ZM10.5 5V2.0405C11.8735 2.2585 13.081 3.368 13.8995 5H10.5ZM14.3255 6C14.7025 7.0415 14.935 8.23 14.984 9.5H10.5V6H14.3255ZM9.5 2.0405V5H6.1005C6.9185 3.368 8.1265 2.2585 9.5 2.0405ZM9.5 6V9.5H5.016C5.065 8.23 5.2975 7.0415 5.6745 6H9.5ZM4.017 9.5H2.025C2.104 8.23 2.4755 7.0415 3.0785 6H4.6305C4.278 7.0645 4.063 8.2475 4.017 9.5ZM5.016 10.5H9.5V14H5.6745C5.2975 12.9585 5.065 11.7705 5.016 10.5ZM9.5 15V17.9595C8.1265 17.741 6.9185 16.632 6.1005 15H9.5V15ZM10.5 17.9595V15H13.9C13.0815 16.632 11.8735 17.741 10.5 17.9595ZM10.5 14V10.5H14.9845C14.935 11.7705 14.703 12.9585 14.326 14H10.5ZM15.9835 10.5H17.9745C17.896 11.7705 17.5245 12.9585 16.921 14H15.369C15.722 12.9355 15.937 11.753 15.9835 10.5ZM15.9835 9.5C15.937 8.2475 15.722 7.0645 15.369 6H16.921C17.5245 7.0415 17.896 8.23 17.9745 9.5H15.9835ZM16.2395 5H14.988C14.6295 4.198 14.185 3.4925 13.6785 2.9005C14.673 3.4165 15.5445 4.1335 16.2395 5ZM6.3215 2.9005C5.8145 3.4925 5.37 4.198 5.0115 5H3.7605C4.4555 4.1335 5.327 3.417 6.3215 2.9005ZM3.7605 15H5.012C5.37 15.802 5.8145 16.5075 6.3215 17.099C5.327 16.583 4.4555 15.8665 3.7605 15ZM13.6785 17.099C14.1855 16.507 14.6295 15.802 14.988 15H16.2395C15.5445 15.8665 14.673 16.583 13.6785 17.099Z",
    fill: "url(#paint0_linear_15528_34338)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15528_34338",
    x1: 10,
    y1: 1,
    x2: 10,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#713171"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15528_34338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(1 1)"
  })))));
};
export { SvgWebsiteSdkSmallIcon as ReactComponent };
export default __webpack_public_path__ + "website-sdk-small-icon.svg";